const removeButtonsArray = [
  'BGColor',
  'TextColor',
  'Format',
  'Font',
  'FontSize',
  'Maximize',
  'ShowBlocks',
  'About',
  'Save',
  'Print',
  'NewPage',
  'Templates',
  'Cut',
  'Copy',
  'Paste',
  'PasteText',
  'PasteFromWord',
  'Replace',
  'Preview',
  'SelectAll',
  'Scayt',
  'Form',
  'Checkbox',
  'Radio',
  'TextField',
  'Textarea',
  'Select',
  'Button',
  'HiddenField',
  'CopyFormatting',
  'RemoveFormat',
  'Outdent',
  'Blockquote',
  'CreateDiv',
  'JustifyLeft',
  'JustifyCenter',
  'JustifyRight',
  'JustifyBlock',
  'Language',
  'BidiRtl',
  'BidiLtr',
  'Anchor',
  'Image',
  'Flash',
  'Table',
  'HorizontalRule',
  'Smiley',
  'SpecialChar',
  'PageBreak',
  'Iframe',
  'Indent',
  'Subscript',
  'Strike',
  'Superscript',
  'Underline',
  'Source'
]

export default {
  versionCheck: false,
  bodyClass: 'ContentPreview',
  contentsCss: `${window.origin}/ckeditorStyle.css`,
  allowedContent: true,
  height: '65vh',
  stylesSet: [
    {
      name: 'Título',
      element: 'h1',
      attributes: { class: 'h1' }
    },
    {
      name: 'Subtítulo h2',
      element: 'h2',
      attributes: { class: 'h2' }
    },
    {
      name: 'Subtítulo h3',
      element: 'h3',
      attributes: { class: 'h3' }
    },
    {
      name: 'Subtítulo h4',
      element: 'h4',
      attributes: { class: 'h4' }
    },
    {
      name: 'Subtítulo h5',
      element: 'h5',
      attributes: { class: 'h5' }
    },
    {
      name: 'Subtítulo h6',
      element: 'h6',
      attributes: { class: 'h6' }
    },
    {
      name: 'Autores',
      element: 'p',
      attributes: { class: 'autores' }
    },
    {
      name: 'Legenda',
      element: 'p',
      attributes: { class: 'legenda' }
    },
    {
      name: 'Texto',
      element: 'p',
      attributes: { class: 'texto' }
    },
    {
      name: 'Título JPG e Vídeo',
      element: 'p',
      attributes: { class: 'tituloJPGeVID' }
    },
    {
      name: 'Link JPG',
      element: 'p',
      attributes: { class: 'linkJPG' }
    },
    {
      name: 'Medicamento - Subtítulo',
      element: 'span',
      attributes: { class: 'medicamentos_subtitulos_wysiwyg' }
    },
    {
      name: 'Medicamento - Descrição',
      element: 'span',
      attributes: { class: 'medicamentos_subtitulos' }
    }
  ],
  toolbarGroups: [
    { name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
    { name: 'styles', groups: ['styles'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'document', groups: ['mode', 'doctools', 'document'] },
    { name: 'forms', groups: ['forms'] },
    { name: 'links', groups: ['links'] },
    { name: 'insert', groups: ['insert'] },
    { name: 'colors', groups: ['colors'] },
    { name: 'tools', groups: ['tools'] },
    { name: 'others', groups: ['others'] },
    { name: 'about', groups: ['about'] }
  ],
  removeButtons: removeButtonsArray.join()
}



// WEBPACK FOOTER //
// ./src/utils/ckeditorDocumentConfig.js